export default "__VITE_ASSET__B70GmSTZ__"